module.exports = __webpack_public_path__ + "static/img/partner_28.e5e6886.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_28.png
// module id = yBVc
// module chunks = 0